import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import {
  defaultWorkspaceMemberFilterState,
  WorkspaceMemberFilter
} from 'src/models/workspaceMemberFilter.interface';
import type { AppThunk } from 'src/store';
import { resetFilters, resetWorkspace } from 'src/store/extraActions';

interface WorkspaceMemberState {
  filter: WorkspaceMemberFilter;
}

const initialState: WorkspaceMemberState = {
  filter: defaultWorkspaceMemberFilterState
};

const slice = createSlice({
  name: 'workspacemember',
  initialState,
  reducers: {
    updateFilter(
      state: WorkspaceMemberState,
      action: PayloadAction<{ filter: WorkspaceMemberFilter }>
    ) {
      const { filter } = action.payload;

      state.filter = { ...state.filter, page: 1, ...filter };
    }
  },
  extraReducers: {
    [resetFilters.type]() {
      return initialState;
    },
    [resetWorkspace.type]() {
      return initialState;
    }
  }
});

export const reducer = slice.reducer;

export const updateWorkspaceMemberFilter =
  (filter: WorkspaceMemberFilter): AppThunk =>
  async (dispatch) => {
    dispatch(slice.actions.updateFilter({ filter }));
  };
